// src/features/dashboard/utils/overviewCard.utils.ts

export const getPercentageColor =
  (
    percentage: number,
  ): string => {

    if (
      percentage >= 100
    ) {
      return 'bg-[#15803D]';
    }

    if (
      percentage >= 80
    ) {
      return 'bg-[#CA8A04]';
    }

    return 'bg-[#DC2626]';
  };

export const getWidth =
  (
    percentage: number,
  ): string =>
    `${Math.min(
      percentage,
      100,
    )}%`;